<template>
  <div
    class="flex md:hidden items-center justify-between text-2xl border-b border-neutral-200 mb-4 h-16 px-4"
    aria-hidden="true"
  >
    <img
      :src="logoPath"
      alt=""
      class="h-7 lg:h-8 -mt-1 w-auto hover:opacity-75 transition focus:outline-none focus:opacity-75"
    />
    <div
      class="py-2"
      @click="$emit('close')"
      @keydown="$emit('close')"
    >
      <fa
        :icon="['fal', 'times']"
        class="inline-block"
      />
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { mapState } from 'vuex';

library.add(faTimes);

export default {
  name: 'VetsterMobileSearchNav',

  computed: {
    ...mapState(['logoPath']),
  },
};
</script>
